import { useMemo } from "react";
import { useApi } from "@/hooks/useApi";
import type { OrgData } from "@/lib/types";

/**
 * 분과(=조직도의 위원회) 이름 목록.
 * org.php 의 comm 그룹 이름을 그대로 사용한다.
 * (comm 이 비어 있으면 groups 에서 gtype === "comm" 만 골라 쓴다.)
 */
export function useDepartments(): string[] {
  const { data } = useApi<OrgData>("org.php");

  return useMemo(() => {
    const groups = data?.comm?.length
      ? data.comm
      : (data?.groups ?? []).filter((g) => g.gtype === "comm");
    const names = groups.map((g) => String(g.name ?? "").trim()).filter(Boolean);
    return Array.from(new Set(names));
  }, [data]);
}